<template>
    <div id="home-layout">
        <header-bar></header-bar>
        <div class="container">
            <router-view/>
        </div>
        <footer-bar></footer-bar>
    </div>
</template>

<script>
    export default {
        name: 'Home',
    }
</script>

<style lang="scss">
    //전역 스타일
    /*
    div.home-layout {
    }
    */
</style>



// WEBPACK FOOTER //
// src/layouts/Home.vue